/*
 * @Descripttion: 公告详情页hooks
 * @Author: 曹博
 * @Date: 2023-08-28 17:38:13
 * @LastEditors: 曹博
 * @LastEditTime: 2023-10-16 15:02:07
 */
import { useEffect, useReducer } from 'react'
import { useLocation } from 'react-router-dom'
import { GET_NOTICE_DETAIL } from '../../api/AnnouncementApi'
import { message } from 'antd'
import { history, useTypedSelector } from '../../redux/store'
import { setModuleDataAction } from '../../modules/pagecache'
import { useDispatch } from 'react-redux'
import { DOWNLOAD_ORDER_FILE } from '../../api/orderManage'
import reducer, {
  initState,
  reloadStateAction,
  setAttachmentListAction,
  setDataSourceAction,
  setIsPreviewModalVisibleAction,
  setPreviewFileUrlAction,
} from './reducer'
import { isResponseCodeSuccess } from '../../tools/util'

const UseXhNoticeDetailHook = () => {
  const dispatchRedux = useDispatch()
  const [pageState, dispatch] = useReducer(reducer, initState)
  const location = useLocation<{ id: string }>()
  const { state } = location
  const { pagekey } = useTypedSelector((state) => state.pageCache)

  // 获取公告详情
  const getNoticeDetail = async (id: string) => {
    const res = await GET_NOTICE_DETAIL({ id: id })
    if (isResponseCodeSuccess(res.code)) {
      message.destroy()
      dispatch(setDataSourceAction(res.data))
      dispatch(
        setAttachmentListAction(
          (res.data.fileList && JSON.parse(res.data.fileList)) || [],
        ),
      )
    }
  }

  // 获取缓存数据
  const getpagecache = () => {
    const pathName = history.location.pathname
    const data = pagekey.filter((item) => item.key === pathName)
    if (data.length === 1) {
      return data[0].data
    }
    return null
  }

  // 缓存数据
  const onCache = () => {
    // 缓存存数据
    const pathName = history.location.pathname
    const action = setModuleDataAction({
      key: pathName,
      data: {
        pageState: pageState, // 当前状态
      },
    })
    dispatchRedux(action)
  }

  // 预览
  const showPreviewModal = (item: any) => {
    dispatch(setPreviewFileUrlAction(item.baseUrl + item.newFilePath))
    dispatch(setIsPreviewModalVisibleAction(true))
  }

  // 关闭预览弹窗
  const cancelPreviewModal = () => {
    dispatch(setIsPreviewModalVisibleAction(false))
  }

  // 下载附件
  const onDownloadFile = (item: any) => {
    DOWNLOAD_ORDER_FILE({
      url: item.newFilePath,
      fileName: item.filename,
    })
  }

  useEffect(() => {
    const flag = getpagecache()
    if (flag && !state) {
      dispatch(reloadStateAction(flag.pageState))
    } else if (state && state.id) {
      getNoticeDetail(state.id)
    }

    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    // 缓存存数据
    onCache()
    // eslint-disable-next-line
  }, [pageState])

  return {
    hookstate: pageState,
    showPreviewModal,
    cancelPreviewModal,
    onDownloadFile,
  }
}
export default UseXhNoticeDetailHook
/*
 * @Descripttion: 公告详情页hooks
 * @Author: 曹博
 * @Date: 2023-08-28 17:38:13
 * @LastEditors: 曹博
 * @LastEditTime: 2023-10-16 15:02:07
 */
import { useEffect, useReducer } from 'react'
import { useLocation } from 'react-router-dom'
import { GET_NOTICE_DETAIL } from '../../api/AnnouncementApi'
import { message } from 'antd'
import { history, useTypedSelector } from '../../redux/store'
import { setModuleDataAction } from '../../modules/pagecache'
import { useDispatch } from 'react-redux'
import { DOWNLOAD_ORDER_FILE } from '../../api/orderManage'
import reducer, {
  initState,
  reloadStateAction,
  setAttachmentListAction,
  setDataSourceAction,
  setIsPreviewModalVisibleAction,
  setPreviewFileUrlAction,
} from './reducer'
import { isResponseCodeSuccess } from '../../tools/util'

const UseXhNoticeDetailHook = () => {
  const dispatchRedux = useDispatch()
  const [pageState, dispatch] = useReducer(reducer, initState)
  const location = useLocation<{ id: string }>()
  const { state } = location
  const { pagekey } = useTypedSelector((state) => state.pageCache)

  // 获取公告详情
  const getNoticeDetail = async (id: string) => {
    const res = await GET_NOTICE_DETAIL({ id: id })
    if (isResponseCodeSuccess(res.code)) {
      message.destroy()
      dispatch(setDataSourceAction(res.data))
      dispatch(
        setAttachmentListAction(
          (res.data.fileList && JSON.parse(res.data.fileList)) || [],
        ),
      )
    }
  }

  // 获取缓存数据
  const getpagecache = () => {
    const pathName = history.location.pathname
    const data = pagekey.filter((item) => item.key === pathName)
    if (data.length === 1) {
      return data[0].data
    }
    return null
  }

  // 缓存数据
  const onCache = () => {
    // 缓存存数据
    const pathName = history.location.pathname
    const action = setModuleDataAction({
      key: pathName,
      data: {
        pageState: pageState, // 当前状态
      },
    })
    dispatchRedux(action)
  }

  // 预览
  const showPreviewModal = (item: any) => {
    dispatch(setPreviewFileUrlAction(item.baseUrl + item.newFilePath))
    dispatch(setIsPreviewModalVisibleAction(true))
  }

  // 关闭预览弹窗
  const cancelPreviewModal = () => {
    dispatch(setIsPreviewModalVisibleAction(false))
  }

  // 下载附件
  const onDownloadFile = (item: any) => {
    DOWNLOAD_ORDER_FILE({
      url: item.newFilePath,
      fileName: item.filename,
    })
  }

  useEffect(() => {
    const flag = getpagecache()
    if (flag && !state) {
      dispatch(reloadStateAction(flag.pageState))
    } else if (state && state.id) {
      getNoticeDetail(state.id)
    }

    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    // 缓存存数据
    onCache()
    // eslint-disable-next-line
  }, [pageState])

  return {
    hookstate: pageState,
    showPreviewModal,
    cancelPreviewModal,
    onDownloadFile,
  }
}
export default UseXhNoticeDetailHook
